import * as yup from 'yup';
import { FILE_TREE_FOLDER_MARKER } from './FileTree.utils';

export const filePathSchema = yup
    .string()
    .required('File path is required')
    .matches(/^[^/]/, 'Path must not start with /')
    .matches(/^(?!.*\.\.)/, 'Path traversal sequences are not allowed');

export const folderPathSchema = yup
    .string()
    .required('Folder path is required')
    .matches(/^[^/]/, 'Path must not start with /')
    .matches(/[^/]$/, 'Path must not end with /')
    .matches(/^(?!.*\.\.)/, 'Path traversal sequences are not allowed');

export const fileTreeItemNameSchema = yup
    .string()
    .trim()
    .required('Name is required')
    .matches(/^[^/]+$/, 'Name must not contain /')
    .notOneOf([FILE_TREE_FOLDER_MARKER], 'Reserved name');
